
import { PaymentService } from "@/services/payment-service";
import { Plan } from "@/utils/payments/plan";
import Vue from "vue";
import AppPaymentMethodCard from "./PaymentMethodCard.vue";
export default Vue.extend({
	props: {
		plan: {
			type: Object as ()=>Plan
		}
	},
	methods: {
		async createFirstPayment() {
			await PaymentService.verifyCustomer();
			let link = await PaymentService.addMandate(this.plan);
			if (link != "") {
				window.location.href = link;
			}
		},
	},
	components: {
		AppPaymentMethodCard
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
